import { CircularProgress } from "@mui/material";
import MDBox from "components/MDBox";

const loadingColumn = [{ accessor: "loading", width: "100%", align: "center" }];

const loadingRow = [
  {
    loading: (
      <MDBox
        display="flex"
        alignItems="center"
        justifyContent="center" // Centraliza horizontalmente
        height="100%" // Garante o uso do espaço vertical
        lineHeight={1}
      >
        <CircularProgress color="secondary" />
      </MDBox>
    ),
  },
];

export { loadingColumn, loadingRow };
